import { VinSearchCtxProvider } from "components/VinSearch/VinSearchContext";
import VinSearch from "../../../../components/VinSearch/VinSearch";
import { styles } from "./VinSearchComponent.style";

export interface IVinSearchComponentProps {
  errorMsgOnLoad?: string;
  vinOnLoad?: string;
}

const VinSearchComponent = ({ errorMsgOnLoad, vinOnLoad }: IVinSearchComponentProps) => (
  <VinSearchCtxProvider>
    <div className={styles.vinSearchWrapper()}>
      <VinSearch onLoadProps={{ errorMsgOnLoad, vinOnLoad }} displayBelow={false} />
    </div>
  </VinSearchCtxProvider>
);

export default VinSearchComponent;
